import {FormAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, LanguageService, MessageService  } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FragmentNames, MyChartMedicinePatientDetailAliases } from '../../codegen';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import './my-chart-medicine-patient-detail.css';
import { InformDose } from '../my-chart-medicine-patient/my-chart-medicine-patient-controller';

@Controller({ fragment: FragmentNames.MY_CHART_MEDICINE_PATIENT_DETAIL })
class MyChartMedicinePatientDetailController extends BaseController {

  @Inject(MyChartMedicinePatientDetailAliases.FORM_MEDICINE_PATIENT_DETAIL)
    medicinePatientFormApi!: FormAPI;

  @OnMount(MyChartMedicinePatientDetailAliases.FORM_MEDICINE_PATIENT_DETAIL)
  handleMount(event: MountEvent): void {
    const medicinePatientFormApi = event.target as FormAPI;
    const medicineSequence = this.getHistoryRouteParam<Value>('medicineSequence');

    medicinePatientFormApi.setRecord({});
    HttpService.get(APPLICATION_ENDPOINTS.GET_MC_MEDICINE_PATIENT_DETAIL, { medicamentSequence: medicineSequence, patientId: UserContext.patientId })
      .then(response => response.body as Record<string, Value>)
      .then(data => {

        const localeStr = LanguageService.getCurrentLanguage().replace('_', '-');
        const startDate = data.startDate as string;
        const endDate = data.endDate as string;
        data.startDate = startDate ? moment(startDate).locale(localeStr).format('L') : '-';
        data.endDate = endDate ? moment(endDate).locale(localeStr).format('L') : '-';
        data.notes = data.notes || '-';
        data.dontKnowTheDose = data.dontKnowTheDose?.toString() === InformDose.NOT_INFORMED_DOSE ? MessageService.translate('patient.moda.button-yes') : MessageService.translate('patient.modal.button-cancel');
        data.continuousMedication = data.continuousMedication || '-';
        data.medicine = {}

        medicinePatientFormApi.setData(data);
      });
  }

  @OnClick({ target: MyChartMedicinePatientDetailAliases.ACTION_MEDICINE_INACTIVATE })
  handleBtnInactivateMedicine(): void {
    ModalService.openDialog({closeable: true, fragment: FragmentNames.MY_CHART_MEDICINE_INACTIVATE, title: 'patient.label.justification'})
  }

}
export default MyChartMedicinePatientDetailController;
